module.exports = __webpack_public_path__ + "img/logo.77c4f5ca.svg";